import React, { memo } from 'react'
import { Stack } from '@mui/material'

import Text from '../shared/text/Text'

const FooterLinks = ({ t }) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={4}
      alignItems='center'
      justifyContent='center'
      sx={{ mb: 2, mt: 0 }}
    >
      <Text
        variant='h6'
        label={t('home.copy-right-text', { year: new Date().getFullYear() })}
        fontWeight={500}
        color='text.secondary'
      />
    </Stack>
  )
}

export default memo(FooterLinks)
